import { IKohderekisteri } from '@/sg-kohderekisterit/IKohderekisteri';
import { makeFailure } from '../../sg-core/utils/Result';

export interface IConfiguredHooks {
    usePerson: (personId: number) => { data: { fullname: string; id: number;[key: string]: any } | null; fetching: boolean; };
    useGetLocationData: IKohderekisteri["useGetLocationData"]
};


export const defaultConfiguredHooks: IConfiguredHooks = {
    usePerson: (personId: number) => ({ data: null, fetching: false }),
    useGetLocationData: () => ({ getLocationData: async () => { return makeFailure(new Error("Hello world!")) } })

};